var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "stockDetailDialog",
      attrs: { visible: _vm.dialogVisible, width: "40%" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [_c("stock-detail", { attrs: { stockDetailObj: _vm.stockObj } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }